import angular from 'angular';

/**
 * @ngdoc overview
 * @name commonModule.buttons
 * @description
 * # commonModule.buttons
 * Collection of button directives
 */
const buttons = angular.module('commonModule.buttons', []);

/**
 * @ngdoc directive
 * @name commonModule.buttons.directive:btnConfirm
 * @description
 * Directive for 'confirm' button
 */
buttons.directive('btnConfirm', function () {
    'use strict';
    return {
        restrict: 'AE',
        replace: true,
        scope: false,
        template: '<button class="btn btn-primary btn-addon" ng-click="ok()"><i class="fa fa-check "></i> {{ \'MODAL.CONFIRM.BTN_OK\' | translate }}</button>'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.buttons.directive:btnConfirm
 * @description
 * Directive for 'cancel' button
 */
buttons.directive('btnCancel', function () {
    'use strict';
    return {
        restrict: 'AE',
        replace: true,
        scope: false,
        template: '<button class="btn btn-default" ng-click="cancel()">{{ \'MODAL.CONFIRM.BTN_CANCEL\' | translate }}</button>'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.buttons.directive:btnBack
 * @description
 * Directive for 'back' button
 */
buttons.directive('btnBack', function () {
    'use strict';
    return {
        restrict: 'AE',
        replace: true,
        scope: false,
        template: '<button class="btn btn-default" ng-click="back()">{{ \'MODAL.CONFIRM.BTN_BACK\' | translate }}</button>'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.buttons.directive:btnConfirm
 * @description
 * Directive for 'add' button
 */
buttons.directive('btnAdd', function () {
    'use strict';
    return {
        restrict: 'AE',
        replace: true,
        scope: false,
        transclude: true,
        template: '<button type="button" class="btn btn-primary btn-addon"><i class="fa fa-plus"></i> <ng-transclude></ng-transclude></button>'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.buttons.directive:btnConfirm
 * @description
 * Directive for 'delete' button
 */
buttons.directive('btnDelete', function () {
    'use strict';
    return {
        restrict: 'AE',
        replace: true,
        scope: false,
        transclude: true,
        template: '<button type="button" class="btn btn-danger btn-addon"><i class="fa fa-times"></i> <ng-transclude></ng-transclude></button>'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.buttons.directive:btnConfirm
 * @description
 * Directive for 'save' button
 */
buttons.directive('btnSave', function () {
    'use strict';
    return {
        restrict: 'AE',
        replace: true,
        scope: false,
        transclude: true,
        template: '<button class="btn btn-primary"><ng-transclude></ng-transclude></button>'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.buttons.directive:btnConfirm
 * @description
 * Directive for 'loading' button
 */
buttons.directive('btnLoading', function () {
    'use strict';
    return {
        restrict: 'AE',
        replace: true,
        scope: false,
        template: '<button type="button" class="btn btn-default" disabled="disabled"><span loading-text></span></button>'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.buttons.directive:btnDownload
 * @description
 * Directive for 'download' button
 */
buttons.directive('btnDownload', function () {
    'use strict';
    return {
        restrict: 'AE',
        replace: true,
        scope: false,
        template: '<button type="button" class="btn btn-primary btn-addon"><i class="fa fa-download"></i> {{ \'BUTTONS.DOWNLOAD\' | translate }}</button>'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.buttons.directive:btnUpload
 * @description
 * Directive for 'upload' button
 */
buttons.directive('btnUpload', function () {
    'use strict';
    return {
        restrict: 'AE',
        replace: true,
        scope: false,
        transclude: true,
        template: '<button type="button" class="btn btn-primary btn-addon"><i class="fa fa-upload"></i><ng-transclude></ng-transclude></button>'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.buttons.directive:readWriteBtn
 * @description
 * Directive for Read & Write toogle buttons
 */
buttons.directive('readWriteBtn', function () {
    'use strict';
    return {
        restrict: 'AE',
        replace: true,
        scope: {
            data: '=ngModel',
            disabled: '=btnDisabled',
            btnClass: '@'
        },
        templateUrl: 'views/common/components/readWriteBtn.tpl.html'
    };
});

export default buttons;